import { render } from "./EditCorrectionRequest.vue?vue&type=template&id=e2756f54&ts=true"
import script from "./EditCorrectionRequest.vue?vue&type=script&lang=ts"
export * from "./EditCorrectionRequest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__